import "@tento-ui/components/prompt";

import { LonaWebComponent, html } from "@tento-ui/component";
import { component } from "@tento-ui/component-decorators";
import { css, Style } from "@tento-ui/component-styles";
import { Prompt } from "@tento-ui/components/prompt";
import { Overlay } from "@tento-ui/components/overlay";

@component({
  name: "lona-whoop-success",
})
export class WhoopSuccessPage extends LonaWebComponent {
  $root = this.hydrate<Prompt>("root");
  onSubmit: Option<() => void>;
  private didComplete: Option<() => void>;

  constructor() {
    super();
    this.$root.bind({
      title: "Successfully Connected",
      description: "Your Whoop account has been linked to Lona",
      onSubmit: () => this.didComplete?.(),
    });
  }

  static reveal(
    onSubmit: () => void,
    $overlay: Overlay = Overlay.instance.get(),
  ): Overlay {
    const $e = WhoopSuccessPage.make();
    $e.didComplete = () => {
      onSubmit();
      $overlay.dismiss($e);
    };
    $overlay.reveal($e);
    return $overlay;
  }

  static $styles: Style.Compat[] = [
    css`
      /* Overlay reveals this host at full viewport width; the prompt
       * (max-width: 360px) doesn't self-center, so the host must. */
      :host {
        display: flex;
        justify-content: center;
      }
    `,
  ];

  static $html: Option<HTMLTemplateElement> = html`
    <std-prompt id=root></std-prompt>
  `;
}
